import { useQuery } from '@tanstack/react-query';
import { useParams } from '@tanstack/react-router';
import type { ProjectId } from '@voll-intelligence/domain';
import { queryKeys } from '@web/core/query';
import { projectsRepository } from '@web/data/repositories';
import { t } from '@web/i18n';
import { DangerZoneCard, Scaffold, useOrgContext } from '@web/ui/core';

export function ProjectSettingsPage(): React.JSX.Element | null {
  const { projectId: projectIdParam } = useParams({ strict: false });
  const projectId = projectIdParam as ProjectId;
  const { orgId } = useOrgContext();

  const { data: project, isLoading } = useQuery({
    queryKey: queryKeys.projects.detail(orgId, projectId),
    queryFn: () => projectsRepository.getProject(orgId, projectId),
  });

  if (isLoading || !project) return null;
  const squadCount = project.squads.length;
  const canDelete = project.permissions.includes('kanban:projects:delete');

  return (
    <Scaffold
      body={
        <>
          <div className="mb-3.5">
            <h4 className="m-0 text-base font-medium text-foreground">
              {t('project.editor.settings.title')}
            </h4>
            <p className="m-0 text-meta text-muted-foreground">
              {t('project.editor.settings.hint')}
            </p>
          </div>

          {canDelete ? (
            <DangerZoneCard
              label={t('project.editor.settings.danger.label')}
              title={t('project.editor.settings.danger.title')}
              sub={`${t('project.editor.settings.danger.sub')} (${t('project.editor.settings.danger.squadCount', { count: squadCount })})`}
              buttonLabel={t('project.editor.settings.danger.button')}
              disabled
            />
          ) : null}
        </>
      }
    />
  );
}
